import React, { useState } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import PriceTab from "./PriceTab";
import ColorTabs from "./ColorTabs";
import SizeTabs from "./SizeTabs";
import DesignTabs from "./DesignTabs";

const InventoryPage = () => {
  const [activeKey, setActiveKey] = useState("ColorsRenkler");
  const navigate = useNavigate();

  return (
    <div className="container-fluid py-4">
      <div className="text-center mb-3">
        <Button variant="primary" onClick={() => navigate("/home")}>
          Go Home
        </Button>
      </div>

      <Tabs
        id="inventory-tabs"
        activeKey={activeKey}
        onSelect={(k) => setActiveKey(k)}
        className="mb-3 justify-content-center"
      >
        <Tab eventKey="ColorsRenkler" title="Colors">
          <ColorTabs />
        </Tab>

        <Tab eventKey="Price" title="Price">
          <PriceTab />
        </Tab>

        <Tab eventKey="Size" title="Size">
          <SizeTabs />
        </Tab>
        <Tab eventKey="DesignDimensions" title="Design Dimensions">
  <DesignTabs />
</Tab>

      </Tabs>
    </div>
  );
};

export default InventoryPage;
